import { FAQData } from '../../common/initialValues/initialValues';
import AccordionFAQ from '../../components/dashboard/AccordionFAQ';

export const FAQ = () => {
  return (
    <div className='simplydoc-page'>
      <div className='simplydoc-page__section-one'>
        <h1 className='font-h1-regular color-white'>Frequently Asked Questions</h1>
      </div>
      <div className='simplydoc-page__secrion-two'>
        <div className='accordion'>
          {FAQData.map(({ title, content }, index) => (
            <AccordionFAQ key={index} id={index} title={title} content={content} />
          ))}
        </div>
      </div>
    </div>
  );
};
